import { useLocation } from '@reach/router'

/**
 * Hook para obter o pathname da página atual
 * Funciona tanto no build-time (SSG) quanto no client-side
 * @returns pathname da URL atual
 */
const usePath = (): string => {
  const location = useLocation()
  return location.pathname
}

export default usePath
